const URL_FILTER_FIELDS = [
  'accounting_account_code',
  'accounting_date_from',
  'accounting_date_to',
  'company_id',
  'business_id',
  'store_id',
  'document_no',
  'keyword',
  'bank_account_id',
  'include_children',
];

const normalizeBooleanQueryValue = (value) =>
  ['1', 'true', 'yes', 'y'].includes(String(value || '').trim().toLowerCase()) ? 1 : 0;

export const parseAccountingReportSearch = (search = '') => {
  const searchParams = new URLSearchParams(search);
  return URL_FILTER_FIELDS.reduce((result, field) => {
    if (!searchParams.has(field)) return result;
    const value = searchParams.get(field)?.trim();
    if (!value) return result;
    result[field] = field === 'include_children' ? normalizeBooleanQueryValue(value) : value;
    return result;
  }, {});
};
